import React from "react";
import { Input } from "reactstrap";
import { COLOR_AUTO } from "./CheckFecha";

// Campo de texto o fecha de los tracking. Si nadie lo ha capturado y el sistema
// ya sabe el dato (del pedido, la OC, el embarque o el modelo), lo muestra en
// azul; al escribir encima se guarda lo tecleado, y si se borra regresa al automatico.
export const CampoAuto = ({ tipo = "text", valor, auto, onChange, ingles = false }) => {
  const usaAuto = !valor && !!auto;
  return (
    <Input bsSize="sm" type={tipo}
      value={usaAuto ? auto : valor || ""}
      style={usaAuto ? { color: COLOR_AUTO, fontStyle: "italic" } : undefined}
      title={usaAuto
        ? (ingles ? "Automatic: taken from the order, the PO or the shipment. Type to change it." : "Automático: sale del pedido, la OC o el embarque. Escribe para cambiarlo.")
        : undefined}
      onChange={(e) => onChange(e.target.value)} />
  );
};

export default CampoAuto;
